/* =========================================================
   SOM HER · Hot Sale runtime JS
   - Free shipping bar (listens to cartUpdate)
   - Countdown timers (announcement bar + PDP block)
   ========================================================= */
(function () {
	'use strict';

	/* ---------- Free shipping bar ---------- */
	function formatMoneyFallback(cents, format) {
		var amount = (cents / 100).toLocaleString('es-MX', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
		if (format && format.indexOf('{{amount}}') !== -1) {
			return format.replace('{{amount}}', amount);
		}
		return '$' + amount + ' MXN';
	}

	function formatMoney(cents, format) {
		if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
			try {
				return window.Shopify.formatMoney(cents, format);
			} catch (e) {
				// fallthrough
			}
		}
		return formatMoneyFallback(cents, format);
	}

	function updateShippingBar(bar, totalCents) {
		var threshold = parseInt(bar.dataset.thresholdCents, 10) || 0;
		var current = typeof totalCents === 'number' ? totalCents : parseInt(bar.dataset.currentCents || '0', 10);
		var template = bar.dataset.templateMessage || '';
		var success = bar.dataset.successMessage || '';
		var moneyFormat = bar.dataset.moneyFormat || '';

		var remaining = Math.max(threshold - current, 0);
		var reached = current >= threshold && current > 0;
		var pct = threshold > 0 ? Math.min((current / threshold) * 100, 100) : 0;

		var messageEl = bar.querySelector('[data-somher-shipping-message]');
		var fillEl = bar.querySelector('[data-somher-shipping-fill]');

		if (fillEl) fillEl.style.width = pct + '%';
		if (reached) {
			bar.classList.add('is-success');
			if (messageEl) messageEl.textContent = success;
		} else {
			bar.classList.remove('is-success');
			if (messageEl) {
				var formattedRemaining = formatMoney(remaining, moneyFormat);
				messageEl.innerHTML = template.replace('{amount}', '<strong>' + formattedRemaining + '</strong>');
			}
		}
	}

	function refreshAllShippingBars(totalCents) {
		document.querySelectorAll('[data-somher-shipping-bar]').forEach(function (bar) {
			updateShippingBar(bar, totalCents);
		});
	}

	function attachShippingBarListener() {
		if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
			return;
		}
		subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
			if (event && event.cartData && typeof event.cartData.total_price === 'number') {
				refreshAllShippingBars(event.cartData.total_price);
			} else {
				// fallback: fetch /cart.js
				fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
					.then(function (r) { return r.json(); })
					.then(function (cart) {
						if (cart && typeof cart.total_price === 'number') {
							refreshAllShippingBars(cart.total_price);
						}
					})
					.catch(function () {});
			}
		});
	}

	/* ---------- Countdown timers ---------- */
	function pad(n) { return n < 10 ? '0' + n : '' + n; }

	function tick(el) {
		var endStr = el.dataset.endDate;
		if (!endStr) return;
		var end = new Date(endStr).getTime();
		if (isNaN(end)) return;

		var now = Date.now();
		var diff = Math.max(end - now, 0);
		var d = Math.floor(diff / 86400000);
		var h = Math.floor((diff % 86400000) / 3600000);
		var m = Math.floor((diff % 3600000) / 60000);
		var s = Math.floor((diff % 60000) / 1000);

		var dEl = el.querySelector('[data-somher-cd-days]');
		var hEl = el.querySelector('[data-somher-cd-hours]');
		var mEl = el.querySelector('[data-somher-cd-mins]');
		var sEl = el.querySelector('[data-somher-cd-secs]');
		if (dEl) dEl.textContent = pad(d);
		if (hEl) hEl.textContent = pad(h);
		if (mEl) mEl.textContent = pad(m);
		if (sEl) sEl.textContent = pad(s);

		if (diff <= 0) {
			el.classList.add('is-ended');
			var endedText = el.dataset.endedText;
			if (endedText) {
				var msg = el.querySelector('[data-somher-cd-ended]');
				if (msg) {
					msg.textContent = endedText;
					msg.hidden = false;
				}
			}
			if (el._somherInterval) {
				clearInterval(el._somherInterval);
				el._somherInterval = null;
			}
		}
	}

	function initCountdowns() {
		document.querySelectorAll('[data-somher-countdown]').forEach(function (el) {
			if (el._somherInit) return;
			el._somherInit = true;
			tick(el);
			el._somherInterval = setInterval(function () { tick(el); }, 1000);
		});
	}

	/* ---------- PDP: move inline price badges next to .price-main ---------- */
	function moveInlineBadges() {
		document.querySelectorAll('[data-somher-inline-badge]').forEach(function (wrap) {
			if (wrap._somherMoved) return;
			var container = wrap.closest('product-info, .tpt-product, .shopify-section');
			if (!container) return;
			var priceMain = container.querySelector('.price-main');
			if (!priceMain) return;
			priceMain.appendChild(wrap);
			priceMain.classList.add('has-somher-inline-badge');
			wrap._somherMoved = true;
		});
	}

	/* ---------- Bootstrap ---------- */
	function init() {
		attachShippingBarListener();
		initCountdowns();
		moveInlineBadges();
		// Re-init when cart drawer opens (lazy DOM in some themes) or cart sections re-render.
		document.addEventListener('shopify:section:load', function () {
			initCountdowns();
			moveInlineBadges();
		});
		document.addEventListener('shopify:section:reorder', initCountdowns);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
